
        import {
            generateBrowseSchema,
            invokeSchema,
        } from '@lib/utils/schema';
        import {registerPageAdapter} from '@src/lib/utils/pageAdapter';
        const initPage = async () => {
            await registerPageAdapter({
                openThemeAdapter: true,
                openFontAdapter: true,
                // 该页面rem规则和默认的不一致，其他页面按需使用该属性
                closeRemAdapter: true
            });
            document.getElementById('app').style.visibility = 'visible';
        };
        initPage();
        const jumpUrl = function (e) {
            if (e?.target?.nodeName === 'A') {
                e.stopImmediatePropagation();
                e.preventDefault();
                const url = e.target.href;
                const schema = generateBrowseSchema({
                    url,
                });
                invokeSchema(schema);
            }
        }
        document.addEventListener('click', e => jumpUrl(e), true);
    